import React from 'react';
import styled from 'styled-components';

import Spacer from 'components/s2/Spacer';
import UnlockWalletButton from 'components/wallet/UnlockWalletButton';
import { KATANA_PERPS } from 'config/constants';
import { formatNumber2 } from 'lib/display/formatting';
import { useSelector } from 'reduxState/storeCore';

import BankrollMessage from './BankrollMessage';
import BankrollModalLayout from './BankrollModalLayout';

const Heading = styled.div`
  color: var(--white);
  font-size: var(--medium);
  font-style: normal;
  line-height: normal;
`;

const ExplainText = styled.div`
  padding: 0 4px 1px;
  font-size: var(--medium);
  line-height: normal;
`;

const MessageWrap = styled.div`
  padding-top: 16px;
  color: var(--gray4c);
  font-size: var(--small);
  font-style: normal;
  line-height: normal;
`;

export default function BankrollConnectModal({
  onClose,
  quantity,
  message,
}: {
  onClose?: () => void;
  quantity?: string;
  message?: string;
}) {
  const isMobile = useSelector(state => state.screen.isMobile);
  return (
    <BankrollModalLayout quantity={quantity} onClose={onClose}>
      <ExplainText>
        <Heading>Welcome to {KATANA_PERPS}!</Heading>
        {message ? (
          <MessageWrap>
            <BankrollMessage message={message} />
          </MessageWrap>
        ) : (
          <span>
            Connect your wallet to get $
            {quantity ? formatNumber2(quantity, 2, 0) : '$'} and start trading
            now!
          </span>
        )}
      </ExplainText>
      <Spacer height={16} />
      <div>
        <UnlockWalletButton widePadding inline={!isMobile} onClick={onClose} />
      </div>
    </BankrollModalLayout>
  );
}
